module.exports = __webpack_public_path__ + "img/299.2eda8f71.png";